enum FomatterType {
    TEL,
    DATE,
    BIZ,
    TIME,
}

export default FomatterType
